import React from 'react';

const WaypointLine = ({ start, end, isCompleted }) => {  
  const lineWidth = 20; // Breite des Weges
  const lineBorderColor = "black"; // Farbe des Randes
  const lineColor = "beige"; // Farbe des Weges
  const borderThickness = 2; // Dicke des Randes
  const completedLineWidth = 8; // Breite der Linie für den erreichten Weg
  const completedLineColor = "darkgreen"; // Farbe der Linie für den erreichten Weg

  return (
    <>
      {/* Rand der Linie */}
      <line 
        x1={start.x}
        y1={start.y}
        x2={end.x}
        y2={end.y}
        stroke={lineBorderColor}
        strokeWidth={lineWidth + borderThickness * 2}
        
      />
      {/* Weg selbst */}
      <line 
        x1={start.x}
        y1={start.y}
        x2={end.x}
        y2={end.y}
        stroke={lineColor}
        strokeWidth={lineWidth}
      />
      {/* Linie für erreichten Weg */}
      {isCompleted && (
        <line 
          x1={start.x}
          y1={start.y}
          x2={end.x}
          y2={end.y}
          stroke={completedLineColor}
          strokeWidth={completedLineWidth}
          strokeDasharray="8,3" // Erzeugt eine gestrichelte Linie          
        />
      )}
    </>
  );
};

export default WaypointLine;
